import { NextGameSchema } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { fetchForDefaultTeam } from './fetchForDefaultTeam';

// The default team's next scheduled fixture; null when there is none or it can't be loaded.
export const homeNextGameAtom = atom(get =>
  fetchForDefaultTeam(
    get,
    'homeNextGame',
    teamId => `/team/${teamId}/next-game`,
    response => NextGameSchema.parse(response),
  ),
);
